import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import * as theme from '../../../theme';
import SearchBox from "../../SearchBox";
import TruCard from "../../TruCard";
import { sortPeople } from "../../../functions/Sorting";
import { CheckCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

export default function PractitionerList(props) {
  const [practitionersOnDisplay, setPractitionersOnDisplay] = useState(sortPeople([]));
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 15;
  const propertyList = ['firstName', 'lastName', 'email', 'businessName'];
  const navigate = useNavigate();

  useEffect(() => {
    if (props && props.practitionerList != null) {
      setPractitionersOnDisplay(sortPeople(props.practitionerList));
      setCurrentPage(1);
    }
  }, [props.practitionerList])

  async function findPractitioners(searchText) {
    if (searchText === '') {
      setPractitionersOnDisplay(sortPeople(props.practitionerList));
      setCurrentPage(1);
      return;
    } else if (searchText.length > 2) {
      const practitionersToDisplay = await props.practitionerList.reduce((pList, p) => {
        if (propertyList.some(prop => p[prop] != null && p[prop].toLowerCase().includes(searchText.toLowerCase()))) {
          pList.push(p);
        }
        return pList;
      }, []);
      setPractitionersOnDisplay(sortPeople(practitionersToDisplay));
      setCurrentPage(1);
    }
    return;
  }

  function goToPractitioner(id) {
    navigate(`/practitioners/${id}`);
  }

  const totalPages = Math.ceil(practitionersOnDisplay.length / pageSize);
  const displayedPractitioners = practitionersOnDisplay.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <TruCard title={'Practitioner List'}>
      <SearchBox searchText={(searchText) => findPractitioners(searchText)} />
      <div style={theme.Container.listRow}>
        {displayedPractitioners != null && displayedPractitioners.map(p => {
          return (
            <div 
              key={p.id}
              className='hoverCard'
              style={theme.Cards.card}
              onClick={() => goToPractitioner(p.id)}
            >
              <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <CheckCircle sx={{ fontSize: 20 }} color={p.onboardingComplete ? 'on' : 'off'} />
                <div style={{ marginLeft: 7 }}>
                  <div style={theme.Cards.client}>{p.lastName}, {p.firstName}</div>
                  {p.businessName && <div style={theme.Cards.clientBusiness}>{p.businessName}</div>}
                  <div style={theme.Cards.clientDetail}>{p.email}</div>
                </div>
              </div>
            </div>
            )
        })}
      </div>
      {practitionersOnDisplay.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ flex: 0.3, maxWidth: 60 }}
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1} 
          >
            <ArrowBack />
          </Button>
          <span>{currentPage} of {totalPages}</span>
          <Button
            variant="contained"
            color="primary"
            sx={{ flex: 0.3, maxWidth: 60 }}
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages} 
          >
            <ArrowForward />
          </Button>
        </div>
      )}
    </TruCard>
  );
}